import { useEffect, useRef, type RefObject } from "react";

/**
 * Moves focus to an element once, the first time `ready` is true, so screen
 * readers announce content that renders after a loading state. Focus stays put
 * when the user or a dialog already has it.
 */
export function useFocusWhenReady(ref: RefObject<HTMLElement | null>, ready: boolean): void {
  const hasRunRef = useRef(false);

  useEffect(() => {
    const element = ref.current;
    if (!ready || hasRunRef.current || !element) {
      return;
    }
    hasRunRef.current = true;

    const active = document.activeElement;
    const focusIsFree = !active || active === document.body || active.id === "main-content";
    if (!focusIsFree || document.querySelector('[aria-modal="true"]')) {
      return;
    }
    element.focus({ preventScroll: true });
  }, [ready, ref]);
}

export default useFocusWhenReady;
